// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { axInst } from "./Service"; // your secure axios instance

// const ProtectedRoute = ({ element: Element, dashboardName, ...rest }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading
//   const [dashboards, setDashboards] = useState([]);

//   useEffect(() => {
//     const checkAuth = async () => {
//       try {
//         // Call a protected endpoint to verify session via HttpOnly cookie
//         const profileRes = await axInst.get("user-profile");
//         setIsAuthenticated(true);

//         // Fetch dashboards from sessionStorage or backend
//         const storedDashboards =
//           JSON.parse(sessionStorage.getItem("dashboards")) || [];
//         setDashboards(storedDashboards);
//       } catch (err) {
//         // If request fails → logout / redirect
//         setIsAuthenticated(false);
//         window.location.href = window.location.origin; // login page
//       }
//     };

//     checkAuth();
//   }, []);

//   if (isAuthenticated === null) {
//     // Still verifying session
//     return null; // or a loader
//   }

//   // Dashboard permission check
//   if (!dashboards.includes(dashboardName)) {
//     return <Navigate to="/home" replace />;
//   }

//   // Authorized → render component
//   return <Element {...rest} />;
// };

// export default ProtectedRoute;

// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { axInst } from "./Service";

// const ProtectedRoute = ({ element: Element, dashboardName, ...rest }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(null);
//   const [isAuthorized, setIsAuthorized] = useState(null);

//   useEffect(() => {
//     const verifyAccess = async () => {
//       try {
//         // ✅ Verify session via HttpOnly cookie
//         await axInst.get("user-profile", { withCredentials: true });
//         setIsAuthenticated(true);

//         // ✅ Fetch dashboard permissions
//         const dashRes = await axInst.post(
//           "dashboard",
//           {}, // must send empty body
//           { withCredentials: true }
//         );

//         const backendDashboards = dashRes.data || [];

//         // ✅ Extract names safely (index 1)
//         const allowedNames = backendDashboards
//           .map((item) => item[1])
//           .filter(Boolean)
//           .map((name) => name.trim().toLowerCase());

//         // ✅ Normalize requested dashboard
//         const requested = dashboardName.trim().toLowerCase();

//         // ✅ Compare
//         setIsAuthorized(allowedNames.includes(requested));
//       } catch (err) {
//         setIsAuthenticated(false);
//       }
//     };

//     verifyAccess();
//   }, [dashboardName]);

//   // Still loading
//   if (isAuthenticated === null || isAuthorized === null) return null;

//   // Not logged in
//   if (!isAuthenticated) return <Navigate to="/" replace />;

//   // Logged in but not allowed
//   if (!isAuthorized) return <Navigate to="/home" replace />;

//   // Allowed → render component
//   return <Element {...rest} />;
// };

// export default ProtectedRoute;

import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { axInst } from "./Service";

const ProtectedRoute = ({ element: Element, dashboardName, ...rest }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(null);

  useEffect(() => {
    const verifyAccess = async () => {
      try {
        // ❌ Remove cookies — call API WITHOUT cookies
        await axInst.get("user-profile");

        setIsAuthenticated(true);

        // ❌ Remove cookies here also
        const dashRes = await axInst.post("dashboard", {});

        const backendDashboards = dashRes.data || [];

        const allowedNames = backendDashboards
          .map((item) => item[1])
          .filter(Boolean)
          .map((name) => name.trim().toLowerCase());

        const requested = dashboardName.trim().toLowerCase();

        setIsAuthorized(allowedNames.includes(requested));
      } catch (err) {
        setIsAuthenticated(false);
      }
    };

    verifyAccess();
  }, [dashboardName]);

  if (isAuthenticated === null || isAuthorized === null) return null;

  if (!isAuthenticated) return <Navigate to="/" replace />;

  if (!isAuthorized) return <Navigate to="/home" replace />;

  return <Element {...rest} />;
};

export default ProtectedRoute;
